"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeoutModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Typography = require("../Typography");
var _button = require("../button");
var _TimeoutModal = require("./TimeoutModal.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TimeoutModal = function TimeoutModal(props) {
  var testId = props.testId,
    open = props.open,
    timeRemainingInSeconds = props.timeRemainingInSeconds,
    maxTimeInSeconds = props.maxTimeInSeconds,
    logoutOnClick = props.logoutOnClick,
    continueOnClick = props.continueOnClick;
  var classes = (0, _TimeoutModal.useStyles)();
  var timePercentage = timeRemainingInSeconds / maxTimeInSeconds * 100;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    "data-testid": testId,
    className: open ? classes.root : classes.hide
  }, /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "h1",
    className: classes.title
  }, "Session Timeout"), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.progressWrapper
  }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    variant: "static",
    value: timePercentage,
    className: classes.loader
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.timeWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "h1",
    className: classes.time
  }, timeRemainingInSeconds))), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "h3",
    className: classes.detail
  }, "Your session will expire in ", /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.strong
  }, timeRemainingInSeconds, " seconds")), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "h3",
    className: classes.detail
  }, "Click continue to extend your session"), /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_button.SecondaryButton, {
    testId: "testId",
    size: "large",
    className: classes.logoutBtn,
    onClick: logoutOnClick
  }, "Logout"), /*#__PURE__*/_react["default"].createElement(_button.ActionButton, {
    testId: "testId",
    size: "large",
    onClick: continueOnClick
  }, "Continue")));
};
exports.TimeoutModal = TimeoutModal;